/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Liquidity provider creation request
 */
export interface LiquidityProviderCreationRequest {
  name: string;
  shortName: string;
  participateInPriceProtection: boolean;
  supportPriceImprovement: boolean;
  routeOnlyFullOrder: boolean;
  businessEntity: LiquidityProviderCreationRequest.BusinessEntityEnum;
}
export namespace LiquidityProviderCreationRequest {
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
